import { v4 as uuid } from 'uuid';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';
import LinkData from '../../../models/LinkData';

class BlockCarouselItemData {
  id: string;
  image: BlockComponentImage;
  link?: LinkData;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockCarouselItemData {
  export function make(image: string, link?: LinkData): BlockCarouselItemData {
    return {
      id: uuid(),
      image: BlockComponentImage.make(image),
      link,
    };
  }

  export function getDefault(src = ''): BlockCarouselItemData {
    return make(
      src,
      undefined,
    );
  }
}

export default BlockCarouselItemData;
